import React from 'react';

import type { Application } from '@src/@types/app';
import { NotFoundPage } from 'pageModules/NotFoundPage';
import { ServerErrorPage } from 'pageModules/ServerErrorPage';

interface IProps {
  statusCode?: number | null;
}

export function ErrorPage({ statusCode }: IProps) {
  if (statusCode === 404) {
    return <NotFoundPage />;
  }
  return <ServerErrorPage />;
}

ErrorPage.getInitialProps = ({ res, err }: Application.ReduxNextPageContext): IProps => {
  if (res) {
    return { statusCode: res.statusCode };
  }
  return { statusCode: err ? err.statusCode : null };
};
